export enum HttpStatus {
  Success = 200,
  Failed = 400,
  Error = 300,
  Unauthorized = 401
}